module.exports = __webpack_public_path__ + "img/Слой_20.png?30d6607cd21dce030f58ab801f931789";